import { useEffect, useState , useMemo} from "react";
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { makeSideBarActive } from "../../utils/EllowUtils";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { Icon } from '@iconify/react';
import { yupResolver } from "@hookform/resolvers/yup";
import { FormInput } from "../../wrappers/formInput";
import { DropDownInput } from "../../wrappers/selectInput";
import { PhoneInput } from '../../wrappers/phoneInput';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw, ContentState } from "draft-js";
import {  getCompanyDetails, getUserDetails } from './services';
import { useNavigate } from "react-router-dom";
import { Error } from '@progress/kendo-react-labels';
import NotificationAlert from "../../components/notification";
import FormHead from "../../components/headings/FromHead";
import PlacesAutocomplete, {  geocodeByAddress } from 'react-places-autocomplete';


export type CreateCompanyFormFields = {
    honorific: string;
    firstName: string;
    lastName: string;
    workEmail: string;
    companyName: string;
    companyType: any;
    phoneNumber: number;
    aboutCompany: string;
    sourcedBy: string;
    behalfOf: string;
}

interface Props {
  submitCompany?: any;
  recruitersList?: any;
  disable?: boolean;
  error?: {error: boolean, message: string};
}

const validationSchema = Yup.object({
    firstName: Yup.string().required("Field is required"),
    lastName: Yup.string().required("Field is required"),
    workEmail: Yup.string().required("Field is required").email('Please provide a valid Work Email'),
    companyName: Yup.string().required("Field is required"),
    sourcedBy: Yup.string().required("Field is required"),
    behalfOf: Yup.object().required("Field is required").nullable(),
    companyType: Yup.object()
    .required("Field is required")
        .nullable(),
    phoneNumber: Yup.string().required('Field is required')
    .min(5, 'Invalid Phone Number')
    .max(15,'Invalid Phone Number')
   .matches(/(?!'-'$)(?!'+'$)[0-9]+$/,'Invalid Phone Number')
})

const CreateCompany : React.FC<Props> = (
  {
    submitCompany,
    recruitersList,
    disable,
    error
  }
) => {

  
  const formOptions = {
    resolver: yupResolver(validationSchema)
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm<CreateCompanyFormFields>(formOptions);

  const { v4: uuidv4 } = require('uuid');
  const navigate = useNavigate()
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3);
  const breadCrums = ['Positions', 'Create New Position']
  const userLoginId = localStorage.getItem('loginId')
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [mailDisable, setMailDisable] = useState<boolean>(false)
  const [type, setType] = useState<string>('success')
  const [icon, setIcon] = useState<boolean>(true)
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
  const [status, setStatus] = useState<number>()
  const [companyFlag, setCompanyFlag] = useState<boolean>(false)
  const [address, setAddress] = useState('')
  const [locationError, setlocationError] = useState<any>();
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  const [blacklisted, setBlacklisted] = useState<boolean>(false)

  useEffect(() => {
    if (watch().companyType) {
      setMailDisable(false)
      clearErrors('companyType')
    }
  }, [watch().companyType])
  

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    setValue("aboutCompany", JSON.stringify(convertToRaw(contentState)));
  }

  const save = (data: any) => {
    

    if (blacklisted) {
      setIcon(false)
      setType('error')
      displayNotification('Sorry! Unable to process. Please contact at team@ellow.io')
    }
    let hasError: boolean = false
    if(locationArray.length === 0){
      hasError = true
      setlocationError('Field is required')
    }
    let value = {
        "customerStatus": 4,
        "companyType": data.companyType.id,
        "submittedBy": "RECRUITER",
        "userLoginId": userLoginId,
        "sourcedBy" :  data.sourcedBy,
        "behalfOf": data.behalfOf.id,
        "behalfofName": data.behalfOf.name,
        "customerMetadata": {
            "honorific": data.honorific,
            "firstName": data.firstName,
            "lastName": data.lastName,
            "workEmail": data.workEmail.toLowerCase(),
            "companyName": data.companyName,
            "phoneNumber": data.phoneNumber,
            "aboutCompany": data.aboutCompany,
            'googleLocations' : locationArray
        }
    } 
    if (!hasError) {
      submitCompany(value)  
    }   
  }

  const back = () => {
    navigate('/company')
  }

  const onBlur = (e: any) => {  
    
      let domain = e.target.value.split('@')[1]
  
      if (domain === 'gmail.com') {
        getCustomerDetails(e.target.value, watch().companyType && watch().companyType.id)
        setCompanyFlag(true)
      }
      else {
        getCustomerDetails(e.target.value, watch().companyType && watch().companyType.id)
      }
  }

  const getCustomerDetails = (email: string, companyType: number) => {    
    getUserDetails(email, companyType).then((response: any) => {
      setStatus(response.status)
      if (response && response.status === 2 || response && response.status === 3) {
        
        if (response.status === 2) {
          setType('error')
          setIcon(false)
          displayNotification('User with this workmail already exist')
        }
        if (response.status === 3) {
          displayNotification('User from your company already registered')
          setType('error')
          setIcon(false)
        }
       
        setValue('firstName',(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.firstName))
        setValue('honorific',response.data[0].customer_metadata.honorific)
        setValue('lastName',response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.lastName)
        setValue('companyName',response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.companyName)
        setValue('phoneNumber',(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.phoneNumber))
        setValue('sourcedBy',response.data[0].sourced_by)
        setValue('behalfOf', response.data[0].behalf_of)
        
        if(response.data.company_type){
            if(response.data.company_type === 1){
                setValue('companyType', { name: "Hirer", id: 1 })
            }
            else if(response.data.company_type === 2){
                setValue('companyType', { name: "Provider", id: 2 })
            }
            else{
                setValue('companyType',{ name: "Both", id: 3 })  
            }
        }
        const contentState = editorState.getCurrentContent();
        if (JSON.stringify(convertToRaw(contentState)) !== response.data.customer_metadata.aboutCompany) {
          try {
            setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(response.data.customer_metadata.aboutCompany)))); 
          }
          catch (e) {
            setEditorState(EditorState.createWithContent(ContentState.createFromText(response.data.customer_metadata.aboutCompany)));
          }
        }
      }
      if (response.status === 4) {
        displayNotification(response.message)
      }

      if (response.status === 5) {
        setBlacklisted(true)
        setIcon(false)
        setType('error')
        displayNotification('Sorry! Unable to process. Please contact at team@ellow.io')
      }
    })
  }

  const onFocus = (e: any) => {
    if (!(watch().companyType)) {
      setMailDisable(true)
      trigger('companyType')
    }
  }
  
  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
     }, 3000)  
  }

  const companyCheck = (event: any) => {
    if (companyFlag) {
      getCompanyDetails(event.target.value).then((response: any) => {
        if (response && response.status === 1) {
          displayNotification('User from your company already registered')
          setStatus(3)
       }
      })
     }
  }

  const handleSelect = async (value: any) => {

    setlocationError('')
    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
    <form>
      <div className={Styles.createWrap}>
      {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} type={type} icon={icon}>
        {message}
      </NotificationAlert> }
      <div className="half-form-wrap">
        <div className="form-group">
          <div className="half-form-wrap">
            <div className="form-group form-group-30">
              <label className="lablel">&nbsp;</label>
              <DropDownInput<CreateCompanyFormFields>
                name="honorific"
                data={CONSTANTS.titles}
                register={register}
                errors={errors}
                control={control}
              />
            </div>
            <div className="form-group form-group-70">
              <label className="lablel">First Name*</label>
              <FormInput<CreateCompanyFormFields>
                id="firstName"
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                register={register}
                errors={errors}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="lablel">Last Name*</label>
          <FormInput<CreateCompanyFormFields>
            id="lastName"
            type="text"
            name="lastName"
            placeholder="Enter your last name"
            register={register}
            errors={errors}
          />
        </div>   
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <label className="lablel">Company type*</label>
          <DropDownInput<CreateCompanyFormFields>
            name="companyType"
            data={CONSTANTS.companiesType}
            register={register}
            errors={errors}
            control={control}
            textField='name'
            dataItemKey='id'
          />
        </div>
        <div className="form-group">
          <label className="lablel">Mobile*</label>
          <PhoneInput<CreateCompanyFormFields>
            id="phone"
            type="number"
            name="phoneNumber"
            label=""
            size="medium"
            register={register}
            errors={errors}
            control={control}
          />     
        </div>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <label className="lablel">Work email*</label>
          <FormInput<CreateCompanyFormFields>
            id="workEmail"
            type="text"
            name="workEmail"
            placeholder="Enter your work email"
            register={register}
            errors={errors}
            onBlur={onBlur}
            onFocus={onFocus}
            disabled={mailDisable}
          />
        </div>
        <div className="form-group">
          <label className="lablel">Company name*</label>
            <FormInput<CreateCompanyFormFields>
              id="companyName"
              type="text"
              name="companyName"
              placeholder="Enter your Company Name"
              register={register}
              errors={errors}
              onBlur={companyCheck}
            />
        </div>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <label className="lablel">Sourced By</label>
          <DropDownInput<CreateCompanyFormFields>
            name="sourcedBy"
            data={["RECRUITER","PROACTIVE","SALES TEAM","CUSTOMER"]}
            register={register}
            control={control}
            errors={errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel">Source name</label>
          <DropDownInput<CreateCompanyFormFields>
            name="behalfOf"
            data={recruitersList}
            register={register}
            control={control}
            errors={errors}
            dataItemKey="id"
            textField="name"
          />
        </div>
      </div>
      <div className="form-wrap mb-40">
        <div className="form-group">
          <label className="lablel">About the company</label>
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={onEditorStateChange}
            />
        </div>
      </div>
      <div className={Styles.subHeadWrap}>
        <FormHead>Locations</FormHead>
      </div>
      <div className='preference-form-wrapper'>
        <div className="form-group">
          { <PlacesAutocomplete
              value={address}
              onChange={setAddress}
              onSelect={handleSelect}
            >
            {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
              <div className="search-filed">
                <Icon icon="carbon:search"/>
                <input
                  {...getInputProps({
                    placeholder: 'Search Places ...',
                    className: 'location-search-input field',
                  })}
                />
                { suggestions && suggestions.length > 0 && 
                  <div  className="suggestion-list">
                    { loading ? <div className="suggestion-item">...loading</div> : null }
                    {suggestions.map(suggestion => {
                      return (
                        <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                          {suggestion.description}
                        </div>
                      )
                    })}
                  </div>
                }
              </div>
              )}
          </PlacesAutocomplete>}
          <Error>{locationError}</Error>
        </div>
      </div>
      <ul className={Styles.addressList}>
        {locationArray && locationArray.map((item: any) => {
          return (
            <li>
              <Icon icon="ep:location" className={Styles.location} />
              <div className={Styles.addressLine}>
                <div>
                  {item.name}
                </div>
                <div className={Styles.addressAction}>
                  <Icon icon="icon-park-outline:delete" onClick={() => removeLocation(item)}/>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
      { error?.error && <Error>{error?.message}</Error>}
      <div className="action-form">
        <Button onClick={back} variant="cancel">Back</Button>
        <Button disabled={disable || status === 2 || status === 3} onClick={handleSubmit(save)} variant="primary">Save</Button> 
      </div>
    </div>
    </form>
  )
}
export default CreateCompany;